<template>
  <v-container>
    <v-card>
      <v-container>
        <v-card-title class="title-highlight">
          倉庫追加
        </v-card-title>

        <v-layout row wrap>
          <v-flex xs12 sm6>
            <v-text-field
              v-model="warehouseName"
              label="倉庫名"
              :counter="15"
              v-validate="'required|max:15|min:1'"
              data-vv-name="倉庫名"
              :error-messages="errors.collect('倉庫名')"
            ></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm3 align-self-center>
            <v-btn block color="success" dark @click="newWarehouse()">
              <v-icon dark>add</v-icon>追加
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
    <br />
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-container>
          <v-card-title>
            <span class="headline">ステータス設定</span>
          </v-card-title>
          <v-layout row wrap align-center>
            <v-flex>
              <v-select
                v-model="editingWarehouse.isDeleted"
                :items="statuses"
                item-text="statusName"
                item-value="isDeleted"
                label="ステータス"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">
              <v-icon dark>arrow_back</v-icon>戻る
            </v-btn>
            <v-btn color="blue darken-1" flat @click="save">
              <v-icon dark>save</v-icon>変更
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>

    <v-card>
      <v-container>
        <v-card-title class="title-highlight">
          倉庫一覧
        </v-card-title>

        <v-data-table
          :headers="headers"
          :items="warehouses"
          class="elevation-1"
          :custom-sort="customSort"
          hide-actions
        >
          <template slot="headerCell" slot-scope="props">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">{{ props.header.text }}</span>
              </template>
              <span>{{ props.header.text }}</span>
            </v-tooltip>
          </template>
          <template v-slot:items="props">
            <td class="text-xs-left">{{ props.item.warehouseId }}</td>
            <td class="text-xs-left">{{ props.item.warehouseName }}</td>
            <td class="text-xs-left">
              <a @click="editBrand(props.item)" v-if="props.item.isDeleted === '0'">有効</a>
              <a @click="editBrand(props.item)" v-else>無効</a>
            </td>
          </template>
        </v-data-table>
      </v-container>
    </v-card>
    
    <v-layout row wrap style="margin-top: 30px;">
      <v-flex xs12 sm12>
        <v-btn block color="#4C728A" dark :to="{ name: 'admin/new-admin-menu' }">
          <v-icon color="black" left>home</v-icon>Home
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ServerApiCallService from '@/services/ServerApiCallService.js'

export default {
  created() {
    console.log('created')
    ServerApiCallService.setAppJs(this.$parent.$parent.$parent)

    // 倉庫データ取得
    this.getWarehouse()
  },
  methods: {
    customSort(items, index, isDesc) {
      console.log('custom sort. brandId asc')
      items.sort((a, b) => {
        if (!isDesc) {
          return a[index] < b[index] ? -1 : 1
        } else {
          return b[index] < a[index] ? -1 : 1
        }
      })
      return items
    },
    getWarehouse() {
      let thisObj = this
      thisObj.loading = true

      ServerApiCallService.getWarehouse()
        .then(response => {
          thisObj.warehouses = response.data.warehouses
          // 初期表示時の
          thisObj.loading = false
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    newWarehouse() {
      console.log('new warehouse')
      let thisObj = this
      thisObj.loading2 = true

      let request = {
        warehouseName: this.warehouseName
      }

      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$parent.$parent.$parent.showErrorDialog(this.$t('hasInputError'))
          return
        }
        ServerApiCallService.addWarehouse(request)
          .then(response => {
            console.log('completed new warehouse')

            // 倉庫データ取得
            this.getWarehouse()

            thisObj.loading2 = false
            thisObj.warehouseName = ''
            this.$validator.reset()
          })
          .catch(error => {
            console.log('There was an error:', error.response)
          })
      })
    },
    editBrand(item) {
      console.log('open edit warehouse dialog')

      this.editingWarehouse = item

      this.dialog = true
    },
    save() {
      console.log('save dialog')
      console.log('save dialog')

      let sendRequest = {
        warehouse: this.editingWarehouse
      }

      ServerApiCallService.updateWarehouse(sendRequest)
        .then(response => {
          console.log('success updating status')

          this.getWarehouse()
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })

      this.close()
    },
    close() {
      this.dialog = false
    }
  },
  watch: {
    dialog(val) {
      val || this.close()
    }
  },
  data() {
    return {
      loader: null,
      loading: true,
      loading1: false,
      loading2: false,
      warehouseName: '',
      dialog: false,
      editedIndex: -1,
      statuses: [
        {
          statusName: '有効',
          isDeleted: '0'
        },
        {
          statusName: '無効',
          isDeleted: '1'
        }
      ],
      headers: [
        {
          text: 'ID',
          align: 'left',
          value: 'warehouseId'
        },
        {
          text: '倉庫名',
          align: 'left',
          value: 'warehouseName',
          sortable: false
        },
        {
          text: 'ステータス',
          align: 'left',
          value: 'status',
          sortable: false
        }
      ],
      editingWarehouse: {},
      warehouses: []
    }
  }
}
</script>
<style>
.title-highlight {
  font-size: 20px;          /* 🔹 기본 타이틀보다 크게 */
  font-weight: bold;        /* 🔹 굵게 */
  color: #2c3e50;           /* 🔹 진한 남색 계열 */
  /*border-left: 5px solid #4C728A; /* 🔹 왼쪽에 포인트 라인 */
  padding-left: 10px;       /* 🔹 라인과 글자 사이 간격 */
  margin-bottom: 10px;      /* 🔹 아래 여백 */
}
</style>
